/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockPurchaseorderSendemailCtrl
 */
angular.module('mercury.modules.stock.purchaseorder')
.controller('StockPurchaseorderSendemailCtrl', ["dialog", "ngToast", "$scope", "$state", "$stateParams", "StockPurchaseOrders", "StockSuppliers", "userinfo", function(dialog, ngToast, $scope, $state, $stateParams, StockPurchaseOrders, StockSuppliers, userinfo) {
  $scope.siteName = userinfo.companyName();

  /**
  * Initial Setup
  */
  $scope.loading = StockPurchaseOrders.get($stateParams.id).$promise;
  $scope.loading.then(function(order) {
    $scope.fullOrderNumber = order.fullOrderNumber;
    $scope.orderType = (order.creditRequest) ? 'Credit Request' : 'Purchase Order';

    $scope.loading = StockSuppliers.get(order.supplierId).$promise;
    $scope.loading.then(function(supplier) {
      $scope.supplier = supplier;

      $scope.sendModel = {
        purchaseOrderId: order.id,
        email: supplier.email,
        additionalDetails: '',
        updateSupplierEmail: false
      };
    });
  });

  $scope.sendEmail = function() {
    $scope.emailForm.$setSubmitted();

    if ($scope.emailForm.$invalid) {
      ngToast.dismiss();
      ngToast.danger('Please fix the errors on this form.');
      return;
    }

    $scope.sending = StockPurchaseOrders.email($scope.sendModel);
    $scope.sending.then(function() {
      $state.go('^', {}, {reload: true});
    });
  };
}]);
